<div class="error">
  <div class="error-content">
    <h2>{{ status }} - {{ statusText }}</h2>
    <p>
      {{ message }}
    </p>
    <button id="back" type="button" pButton label="Zurück" (click)="back()"></button>
  </div>
</div>
